
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/component-api/DataGrid",
      function () {
        return require("private-next-pages/component-api/DataGrid.mdx");
      }
    ]);
  